<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field
          id="dataCenterCostsPerMonth"
          v-model="chartVariableForm.dataCenterCostsPerMonth"
          label="Kosten Datencenter pro Monat"
        />
      </v-col>
      <v-col>
        <v-text-field
          id="offerCompletionRate"
          v-model="chartVariableForm.offerCompletionRate"
          label="Abschlussquote Angebote"
        />
      </v-col>
      <v-col>
        <v-text-field
          id="offerDelay"
          v-model="chartVariableForm.offerDelay"
          label="Abschlussdauer Angebote"
        />
      </v-col>
      <v-col>
        <v-text-field
          id="priceInformationCompletionRate"
          v-model="chartVariableForm.priceInformationCompletionRate"
          label="Abschlussquote Preisinformation"
        />
      </v-col>
      <v-col>
        <v-text-field
          id="priceInformationDelay"
          v-model="chartVariableForm.priceInformationDelay"
          label="Abschlussdauer Preisinformation"
        />
      </v-col>
      <v-col>
        <v-btn color="primary" :loading="loadingChartData" @click="fetchGoogleChartData">
          Statistik generieren
        </v-btn>
      </v-col>
    </v-row>
    <v-layout row justify-center>
      <v-progress-circular
        v-if="loadingChartData"
        indeterminate
        color="primary"
      />
      <GChart
        v-if="googleChart && !loadingChartData"
        type="ComboChart"
        :data="googleChart.data"
        :options="googleChart.options"
      />
    </v-layout>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { GChart } from 'vue-google-charts'
import axios from 'axios'
export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: 'Statistik - Kosten, Umsatz und Gewinn',
      }
   },
   components: {
      GChart
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      dataCenterCostsPerMonth: {
         type: Number,
         required: true
      },
      offerCompletionRate: {
         type: Number,
         required: true
      },
      offerDelay: {
         type: Number,
         required: true
      },
      priceInformationCompletionRate: {
         type: Number,
         required: true
      },
      priceInformationDelay: {
         type: Number,
         required: true
      }
   },
   data () {
      return {
         googleChart: null,
         chartVariableForm: {
            dataCenterCostsPerMonth: null,
            offerCompletionRate: null,
            offerDelay: null,
            priceInformationCompletionRate: null,
            priceInformationDelay: null
         },
         loadingChartData: false,
      }
   },
   created () {
      this.chartVariableForm.dataCenterCostsPerMonth = this.dataCenterCostsPerMonth
      this.chartVariableForm.offerCompletionRate = this.offerCompletionRate
      this.chartVariableForm.offerDelay = this.offerDelay
      this.chartVariableForm.priceInformationCompletionRate = this.priceInformationCompletionRate
      this.chartVariableForm.priceInformationDelay = this.priceInformationDelay
   },
   methods: {
      fetchGoogleChartData () {
         this.loadingChartData = true
         axios.post(this.route('statistic.investment.googleChartData', 'investment'), this.chartVariableForm)
            .then(response => {
               this.loadingChartData = false
               this.googleChart = response.data
               console.log(response)
            }).catch(error => {
               this.loadingChartData = false
               console.error(error)
            })
      }
   }
}
</script>

<style>

</style>
